import * as React from 'react'
import styled from 'styled-components'

import * as plume from '@ulule/owl-kit-components/next'

import { HorizontalMedia, Image, Content } from './HorizontalMedia'

type MediaStackTihPathProps = {
  listItems: {
    description: React.JSX.Element | React.ReactNode
    image: {
      src: string
      srcSet?: string | null
      alt?: string | null
    }
    title: React.JSX.Element | React.ReactNode
  }[]
}

export function MediaStackWithPath({ listItems }: MediaStackTihPathProps): React.ReactElement {
  return (
    <Section>
      <List>
        {listItems?.map(({ description, image, title }, index) => {
          if (index % 2 === 1) {
            return (
              <Relative key={index}>
                {index !== listItems.length - 1 && <LeftPath />}
                <HorizontalMedia
                  backgroundColor={
                    [plume.COLORS.TEXT_RED, plume.COLORS.PRIMARY_BLUE_500, plume.COLORS.SECONDARY_MINT_700][index]
                  }
                  description={description}
                  image={image}
                  title={title}
                />
                {index !== listItems.length - 1 && <RightPath />}
              </Relative>
            )
          } else {
            return (
              <HorizontalMedia
                key={index}
                reverse
                backgroundColor={
                  [plume.COLORS.TEXT_RED, plume.COLORS.PRIMARY_BLUE_500, plume.COLORS.SECONDARY_MINT_700][index]
                }
                description={description}
                image={image}
                title={title}
              />
            )
          }
        })}
      </List>
    </Section>
  )
}

const Section = styled.section`
  margin: auto auto 48px;
  max-width: 930px;
  position: relative;

  ${Image} {
    z-index: 1;
    position: relative;
    border-radius: 16px;
  }

  @media screen and ${plume.BREAKPOINTS.TABLET} {
    ${Image} {
      max-width: 339px;
      max-height: 226px;
    }

    ${Content} {
      max-width: 400px;
    }
  }
`

const Relative = styled.div`
  position: relative;
`

const List = styled.ul`
  display: flex;
  flex-direction: column;
  list-style: none;
  margin: 0 auto;
  max-width: 800px;
  padding: 0 16px;

  @media screen and ${plume.BREAKPOINTS.TABLET} {
    padding: 0;
  }
`

const LeftPath = styled((props: React.SVGAttributes<SVGSymbolElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="130" height="290" fill="none" {...props}>
      <path
        stroke={plume.COLORS.PRIMARY_GREY_900}
        d="M32.5861 1.59365C69.2372 -1.54756 138.43 49.1903 128.23 127.371C120.158 189.245 72.8292 206.935 38.366 205.242M38.366 205.242C14.0868 204.048 -3.80715 193.234 2.90831 181.47C10.5003 168.171 28.9195 182.401 38.366 205.242ZM38.366 205.242C49.136 231.283 48.243 268.517 6.34424 288.907"
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeDasharray="2 4"
      />
    </svg>
  )
})`
  display: none;

  @media screen and ${plume.BREAKPOINTS.LAPTOP} {
    display: block;
    position: absolute;
    right: -119px;
    top: 80px;
  }
`

const RightPath = styled((props: React.SVGAttributes<SVGSymbolElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="265" height="268" fill="none" {...props}>
      <path
        d="M149.811 19.6832C129.815 27.6515 95.2992 37.8035 64.6039 41.6126M64.6039 41.6126C30.7759 45.8105 1.58791 42.3049 1.58785 19.6832C1.58776 -17.0912 62.4984 5.86617 64.6039 41.6126ZM64.6039 41.6126C65.0234 48.7359 63.1079 56.3671 57.9098 64.1346C16.6812 125.743 -36.1283 205.22 38.6747 257.402C57.9098 268.354 109.203 279.048 160.497 234.21C176.899 218.314 220.563 188.047 264 194.147"
        stroke={plume.COLORS.PRIMARY_GREY_900}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeDasharray="2 4"
      />
    </svg>
  )
})`
  display: none;

  @media screen and ${plume.BREAKPOINTS.LAPTOP} {
    display: block;
    position: absolute;
    left: -168px;
    top: -50px;
  }
`
